import {
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	ViewEncapsulation
} from "@angular/core";

@Component({
	selector: "loader-overlay-component",
	templateUrl: "./loader-overlay.component.html",
	styleUrls: ["./loader-overlay.component.scss"],
	encapsulation: ViewEncapsulation.None
})
export class LoaderOverlayComponent {
	@Input() public show: boolean = false;
}
